import { memo, useState } from "react";
import { useUnit } from "effector-react";
import {
  $UserAddPermissions,
  ACTIONS,
  UserPriorityEnum,
} from "@store/user-store";
import {
  fetchInternalCourses,
  syncInternalCourses,
} from "@store/internal-study/courses-store";
import { Loader } from "@ui/indicators";

import { InternalStudyСoursesTable } from "@components/tables";
import { NavLink } from "react-router-dom";
import { ColorfulButton } from "@components/common/common";
import clsx from "clsx";
import style from "./courses.module.scss";
import useModal from "@modals/modal-hook";
import SyncIcon from "@mui/icons-material/Sync";

const InternalCourses = memo(() => {
  const permissions = useUnit($UserAddPermissions);
  const { open } = useModal();
  const [sync, setSync] = useState<boolean>(false);

  const onSyncAll = async () => {
    setSync(true);
    await syncInternalCourses({
      data: {
        process: "all",
      },
      cb: (err) => {
        if (err) {
        }
        setSync(false);
      },
    });
  };

  const onSyncCourses = async () => {
    setSync(true);
    await syncInternalCourses({
      data: {
        process: "only",
      },
      cb: (err) => {
        if (err) {
        }
        setSync(false);
      },
    });
  };

  const onSyncCourse = async (id: string) => {
    setSync(true);
    await syncInternalCourses({
      data: {
        type: "course",
        process: "only",
        id,
      },
      cb: (err) => {
        if (err) {
        }
        setSync(false);
      },
    });
  };

  const onSyncLesson = async (id: string, course: string) => {
    setSync(true);
    await syncInternalCourses({
      data: {
        type: "lesson",
        process: "all",
        course,
        id,
      },
      cb: (err) => {
        if (err) {
        }
        setSync(false);
      },
    });
  };

  return (
    <div
      className={clsx(
        style.content,
        !permissions.hasPermission(
          ACTIONS.educationalCenter_internalTraining_list_allowedToCreate
        )
          ? style.no_btn
          : ""
      )}
    >
      <div className={style.head}>
        <div className={style.head_container}>
          <div className={style.tabs}>
            {permissions.hasPermission(
              ACTIONS.educationalCenter_internalTraining_list_allowedToShow
            ) && (
              <NavLink to="/study-center/internal/list">
                Список обучений
              </NavLink>
            )}
            {permissions.hasPermission(
              ACTIONS.educationalCenter_internalTraining_student_allowedToShow
            ) && (
              <NavLink to="/study-center/internal/students">
                Список обучающихся
              </NavLink>
            )}
            {permissions.hasPermission(
              ACTIONS.educationalCenter_internalTraining_list_allowedToShow
            ) && (
              <NavLink to="/study-center/internal/comission">Комиссии</NavLink>
            )}
            {permissions.hasPermission(
              ACTIONS.educationalCenter_internalTraining_programs_allowedToShow
            ) && (
              <NavLink to="/study-center/internal/programs">
                Программы обучений
              </NavLink>
            )}
            <div className={style.tabs_active}>Курсы</div>
          </div>
          {permissions.hasRequiredLevel(UserPriorityEnum.Owner) && (
            <div className={clsx(style.courses_top_panel)}>
              <ColorfulButton
                text={"Синхронизировать только курсы и лекции"}
                plusIcon={false}
                customIcon={<SyncIcon />}
                disabled={sync}
                onClick={(e) => {
                  e.stopPropagation();
                  open("ConfirmActionModal", {
                    modalData: {
                      text: `Вы уверены, что хотите обновить курсы из СДО?`,
                    },
                    btnText: "Синхронизировать",
                    onConfirm: onSyncCourses,
                  });
                }}
              />
              <ColorfulButton
                text={"Синхронизировать всё"}
                plusIcon={false}
                customIcon={<SyncIcon />}
                disabled={sync}
                onClick={(e) => {
                  e.stopPropagation();
                  open("ConfirmActionModal", {
                    modalData: {
                      text: `Вы уверены, что хотите обновить курсы из СДО?`,
                    },
                    btnText: "Синхронизировать",
                    onConfirm: onSyncAll,
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
      {sync ? (
        <div className={clsx(style.courses_loader)}>
          <h2>Ожидайте завершения синхронизации</h2>
          <Loader className={clsx(style.courses_loader_content)} />
        </div>
      ) : (
        <InternalStudyСoursesTable
          onSyncCourse={onSyncCourse}
          onSyncLesson={onSyncLesson}
        />
      )}
    </div>
  );
});

export default InternalCourses;
